import React from 'react';
import { Shield, Lock, Eye, FileText } from 'lucide-react';

const PrivacyPolicyPage = () => {
  return (
    <div className="dark-page legal-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="display-huge page-title">Privacy Policy</h1>
          <p className="body-large page-subtitle">
            Last Updated: January 2026
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="legal-content-section">
        <div className="legal-container">
          
          <div className="legal-section">
            <h2 className="legal-heading">Introduction</h2>
            <p className="legal-text">
              The Collins Academy ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or use our services. Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Information We Collect</h2>
            <p className="legal-text">We may collect information about you in a variety of ways. The information we may collect includes:</p>
            <ul className="legal-list">
              <li><strong>Personal Data:</strong> Personally identifiable information, such as your name, email address, telephone number, and demographic information that you voluntarily give to us when you register or when you choose to participate in various activities related to our services.</li>
              <li><strong>Financial Information:</strong> Financial information related to your credit profile, business status, and funding goals that you provide during the application process.</li>
              <li><strong>Derivative Data:</strong> Information our servers automatically collect when you access the site, such as your IP address, browser type, operating system, access times, and the pages you have viewed.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Use of Your Information</h2>
            <p className="legal-text">We may use information collected about you to:</p>
            <ul className="legal-list">
              <li>Create and manage your account</li>
              <li>Process your applications and provide our services</li>
              <li>Email you regarding your account or services</li>
              <li>Send you marketing and promotional communications (with your consent)</li>
              <li>Respond to your comments, questions, and requests</li>
              <li>Improve our website and services</li>
              <li>Monitor and analyze usage and trends</li>
              <li>Prevent fraudulent transactions and protect against criminal activity</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Disclosure of Your Information</h2>
            <p className="legal-text">We may share information we have collected about you in certain situations:</p>
            <ul className="legal-list">
              <li><strong>By Law or to Protect Rights:</strong> If we believe the release of information is necessary to respond to legal process, to investigate or remedy potential violations of our policies, or to protect the rights, property, and safety of others.</li>
              <li><strong>Business Transfers:</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business.</li>
              <li><strong>Third-Party Service Providers:</strong> We may share your information with third parties that perform services for us or on our behalf, including payment processing, data analysis, email delivery, hosting services, and customer service.</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">SMS/Text Messaging</h2>
            <p className="legal-text">
              If you opt in to receive text messages from The Collins Academy, you consent to receive recurring automated marketing and non-marketing text messages at the phone number provided. Message frequency varies. Message and data rates may apply. You can opt out at any time by texting STOP. Text HELP for assistance. Carriers are not liable for delayed or undelivered messages.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Security of Your Information</h2>
            <p className="legal-text">
              We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Your Rights</h2>
            <p className="legal-text">You may at any time:</p>
            <ul className="legal-list">
              <li>Review or change the information in your account</li>
              <li>Request access to your personal data</li>
              <li>Request deletion of your personal data</li>
              <li>Opt out of receiving marketing communications</li>
            </ul>
            <p className="legal-text">
              To exercise these rights, please contact us at information@thecollinsacademy.com
            </p>
          </div>

          <div className="legal-section">
            <h2 className="legal-heading">Contact Us</h2>
            <p className="legal-text">
              If you have questions or comments about this Privacy Policy, please contact us at:
            </p>
            <p className="legal-text">
              <strong>The Collins Academy</strong><br />
              Email: information@thecollinsacademy.com<br />
              Phone: (800) 555-0199
            </p>
          </div>

        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicyPage;
